import { render, staticRenderFns } from "./OrdersReceived.vue?vue&type=template&id=967c97b2&scoped=true&"
import script from "./OrdersReceived.vue?vue&type=script&lang=js&"
export * from "./OrdersReceived.vue?vue&type=script&lang=js&"
import style0 from "./OrdersReceived.vue?vue&type=style&index=0&id=967c97b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967c97b2",
  null
  
)

export default component.exports